// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1r04ze3t{inset:var(--ds-space-0,0)}
._fiawglyw:empty{display:none}
._kqswstnw{position:absolute}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/editor-core/dist/esm/ui/Toolbar/ToolbarPortal.compiled.css"],"names":[],"mappings":"AAAA,WAAW,yBAAyB;AACpC,iBAAiB,YAAY;AAC7B,WAAW,iBAAiB","sourcesContent":["._1r04ze3t{inset:var(--ds-space-0,0)}\n._fiawglyw:empty{display:none}\n._kqswstnw{position:absolute}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
